import { StateCreator } from 'zustand';

import QuestionService from '../service/question.service';
import { GeneratedQuestion } from '../types/chatbot';

export interface TChatbotState {
  questionIds: string[];
  exerciseSubject: string;
  exerciseChapter: string;
}

export interface TChatbotActions {
  createQuestions: (params: CreateQuestionsParams) => Promise<void>;
}

export interface TChatbotSlice extends TChatbotState, TChatbotActions {}

export const initialState: TChatbotState = {
  questionIds: [],
  exerciseSubject: '',
  exerciseChapter: '',
};

export type CreateQuestionsParams = {
  subject: string;
  chapter: string;
  generatedQuestions: GeneratedQuestion[];
};

export const ChatbotSlice: StateCreator<
  TChatbotSlice,
  [['zustand/devtools', never]],
  [],
  TChatbotSlice
> = (set) => ({
  ...initialState,
  createQuestions: async ({ subject, chapter, generatedQuestions }: CreateQuestionsParams) => {
    set({
      exerciseSubject: subject,
      exerciseChapter: chapter,
    });

    const questions = await Promise.all(
      generatedQuestions.map((question) =>
        QuestionService.create({ ...question, explanation: '', subject, chapter })
      )
    );

    set({ questionIds: questions.map((question) => question.data.payload._id) });
  },
});
